/**
 * Helpers para citas CRM: modalidad (labels, colores, iconos)
 * @module utils/appointmentHelpers
 */

import {
  BuildingOffice2Icon,
  VideoCameraIcon,
  QuestionMarkCircleIcon,
} from '@heroicons/react/24/outline';
import type { AppointmentModality } from '@/types/appointment.types';

const MODALITY_CONFIG: Record<
  NonNullable<AppointmentModality>,
  { label: string; bg: string; text: string; icon: typeof BuildingOffice2Icon }
> = {
  in_person: {
    label: 'Presencial',
    bg: 'bg-[#E8F5E9]',
    text: 'text-[#2E7D32]',
    icon: BuildingOffice2Icon,
  },
  video_call: {
    label: 'Videollamada',
    bg: 'bg-[#E3F2FD]',
    text: 'text-[#1565C0]',
    icon: VideoCameraIcon,
  },
};

/** Label en español para la modalidad */
export function getModalityLabel(modality: AppointmentModality | null | undefined): string {
  if (!modality) return 'Sin especificar';
  return MODALITY_CONFIG[modality]?.label ?? modality;
}

/** Clases CSS para badge de modalidad (background + text) */
export function getModalityBadgeClasses(modality: AppointmentModality | null | undefined): string {
  if (!modality) {
    return 'bg-gray-100 text-gray-600';
  }
  const c = MODALITY_CONFIG[modality];
  if (!c) return 'bg-gray-100 text-gray-600';
  return `${c.bg} ${c.text}`;
}

/** Icono React para la modalidad */
export function getModalityIcon(
  modality: AppointmentModality | null | undefined
): typeof BuildingOffice2Icon {
  if (!modality) return QuestionMarkCircleIcon;
  return MODALITY_CONFIG[modality]?.icon ?? QuestionMarkCircleIcon;
}

/** Indica si la cita está completada (permite editar resumen) */
export function isAppointmentCompleted(status: string | null | undefined): boolean {
  return status === 'completed';
}
